import { Trans } from '@lingui/react'
import clsx from 'clsx'
import type { CurrentRefinementsProvided } from 'react-instantsearch-core'
import { connectCurrentRefinements } from 'react-instantsearch-dom'

import { PRODUCT_FILTER_RESET_SFX } from 'shared/experiments/components/NewSerp/consts'
import store from 'shared/store'
import IconCross from 'views/components/atoms/Icon/IconCross'
import TextWithIcon from 'views/components/molecules/TextWithIcon'
import { usePublicConfig } from 'views/utils/shopAndRuntimeConfigUtils'

import {
  currentRefinementAccessorGetRefinementLabel,
  type ExtendedRefinement,
} from './currentRefinementAccessor'
import './CurrentRefinements.scss'

const RemoveFilterButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <button
      name="remove-refinement"
      className="o-current-refinement__remove-button"
      onClick={onClick}
    >
      <TextWithIcon icon={<IconCross />}>
        <span className="u-visuallyhidden">
          <Trans id="general.label.delete" />
        </span>
      </TextWithIcon>
    </button>
  )
}

export const CurrentRefinements = connectCurrentRefinements(
  ({
    isInline,
    items,
    refine,
  }: {
    isInline: boolean
    items: ExtendedRefinement[]
    refine: CurrentRefinementsProvided['refine']
  }) => {
    const { currency } = usePublicConfig()

    if (!items.length) {
      return null
    }

    return (
      <div
        className={clsx({
          'o-current-refinement__inline': isInline,
          'o-current-refinement': !isInline,
        })}
      >
        <ul className={clsx('a-list-reset o-current-refinement__list')}>
          {items.map(refinement => {
            if (!refinement.items) {
              return (
                <li className="o-current-refinement__item">
                  <span className="o-current-refinement__item-inner">
                    {currentRefinementAccessorGetRefinementLabel(
                      refinement,
                      currency
                    )}
                  </span>
                  <RemoveFilterButton
                    onClick={() => {
                      refine(refinement.value)
                      store.dispatch({
                        type: `${PRODUCT_FILTER_RESET_SFX}${refinement.attribute}`,
                      })
                    }}
                  />
                </li>
              )
            }

            return refinement.items.map(subRefinement => {
              return (
                <li className="o-current-refinement__item">
                  <span className="o-current-refinement__item-inner">
                    {subRefinement.label}
                  </span>
                  <RemoveFilterButton
                    onClick={() => {
                      refine(subRefinement.value)
                      store.dispatch({
                        type: `${PRODUCT_FILTER_RESET_SFX}${refinement.attribute}`,
                      })
                    }}
                  />
                </li>
              )
            })
          })}
        </ul>
      </div>
    )
  }
)
